export default __webpack_public_path__ + "static/media/search-white.26a2a835.svg";